import { render, staticRenderFns } from "./pvp.vue?vue&type=template&id=589dca38"
import script from "./pvp.vue?vue&type=script&lang=js"
export * from "./pvp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports